import { useMemo } from 'react';
import { Time } from './types';
import { getYesterdayMinutes, calcPercentageChange, getAllTimeMinutes, SessionRecord } from '../../utils/sessionStatsUtils';

interface SessionStatsProps {
  time: Time;
  minutesSpent: number;
  records?: SessionRecord[];
  streak?: number;
}

const SessionStats = ({ time, minutesSpent, records = [], streak = 0 }: SessionStatsProps) => {
  const yesterdayMinutes = useMemo(() => getYesterdayMinutes(records), [records]);
  const todayTotal = time.totalSessionTime + minutesSpent;

  return (
    <div className="bg-parchment-100 rounded-xl border border-parchment-200 shadow-sm px-6 py-4 w-80 text-center">
      <p className="text-sm font-semibold text-ink mb-2">Session Stats</p>
      <div className="border-t border-parchment-200 pt-2 space-y-1">
        {todayTotal > 0 ? (
          <>
            <p className="text-sm text-ink">Today: <strong>{todayTotal} min</strong></p>
            {yesterdayMinutes > 0 && (
              <p className="text-sm text-ink-muted">
                Yesterday: {yesterdayMinutes} min
                {todayTotal > yesterdayMinutes && (
                  <span className="text-green-500 ml-1">
                    (+{calcPercentageChange(todayTotal, yesterdayMinutes)}%)
                  </span>
                )}
              </p>
            )}
            {streak >= 2 && (
              <span className="inline-block mt-1 text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-700">
                🔥 {streak} day streak
              </span>
            )}
          </>
        ) : (
          <>
            {streak >= 2 && (
              <p className="text-sm text-ink">
                <span className="inline-block text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-700">
                  🔥 {streak} days
                </span>{' '}
                Keep the streak!
              </p>
            )}
            {yesterdayMinutes > 0 && (
              <p className="text-sm text-ink-muted">Yesterday: {yesterdayMinutes} min</p>
            )}
            {streak < 2 && yesterdayMinutes === 0 && records.length > 0 && (
              <p className="text-sm text-ink-muted">
                All time: {getAllTimeMinutes(records)} min
              </p>
            )}
            {records.length === 0 && (
              <p className="text-sm text-ink-muted">First session — great start!</p>
            )}
          </>
        )}
        {minutesSpent > 0 && (
          <p className="text-xs text-ink-muted">Previous: {minutesSpent} min</p>
        )}
      </div>
    </div>
  );
};

export default SessionStats;
